/**
 * Brand 도메인 쿼리 키 팩토리
 *
 * 컨벤션: 도메인명 복수형, 하위 키는 동사/명사
 */

export const brandKeys = {
  all: ["brands"] as const,
  notice: (brandId: string) => ["brands", "notice", brandId] as const,
  products: (brandId: string, exclude?: string) =>
    ["brands", "products", brandId, exclude] as const,
  info: (brandId: string) => ["brands", "info", brandId] as const,
};
